import { FunctionComponent } from 'react'
import useStyles from './styles'
import { TooltipProps } from './types'
import { useValidateProps } from './utils'

export const Tooltip: FunctionComponent<TooltipProps> = ({
  content,
  styles: overrides,
  placement: propPlacement,
  theme: propTheme,
  variant: propVariant,
  tooltipProps,
  children,
}) => {
  const { placement, theme, variant } = useValidateProps({
    propTheme,
    propVariant,
    propPlacement,
  })

  const styles = useStyles({ placement, theme, variant })

  return (
    <div
      {...tooltipProps}
      data-testid="hero-tooltip"
      className="hero-tooltip_root"
      css={[styles.root, overrides?.root]}
    >
      {children}
      <p
        className="hero-tooltip_baloon"
        css={[styles.tooltip, overrides?.tooltip]}
      >
        {content}
        <span css={styles.tooltipArrow} />
      </p>
    </div>
  )
}
